module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Beer-ab9d1d444ba0e4ddf5d8bfe21a108db1.svg";